export default "__VITE_ASSET__1840b87e__"